import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { of, lastValueFrom } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { environment } from '../../environments/environment';

import { EasyDebugDecorator } from '../decorators/easy-debug.decorator';

import { PracticeExam, PracticeExamDetails } from '@app/models/practiceExam';
import { PracticeExamMapper } from '@app/mappers/driving-examens-blanc.mapper';
import { DateService } from './date.service';

@Injectable({ providedIn: 'root' })
@EasyDebugDecorator
export class PracticeExamService {
  constructor(
    private http: HttpClient,
    private dateService: DateService,
    private practiceExamMapper: PracticeExamMapper
  ) {}

  fetchPracticeExams(): Promise<PracticeExam[]> {
    const url: string = `${environment.token_auth_config.apiBase}/v3/practice_exams`;

    return lastValueFrom(
      this.http.get(url).pipe(
        switchMap((data: any) => {
          if (data?.data) {
            const mappedExams: PracticeExam[] = this.practiceExamMapper.mapExamDataArrayToPracticeExamArray(data.data);
            return of(mappedExams);
          }
          return of([]);
        })
      )
    );
  }

  fetchPracticeExamById(examId: string): Promise<PracticeExamDetails | null> {
    const url: string = `${environment.token_auth_config.apiBase}/v3/practice_exams/${examId}`;

    return lastValueFrom(
      this.http.get(url).pipe(
        switchMap((data: any) => {
          if (data?.data) {
            const mappedExam = this.practiceExamMapper.mapExamDataToPracticeExamDetails(data.data);
            return of(mappedExam);
          }
          return of(null);
        })
      )
    );
  }
}
